import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash, FaMobileAlt } from "react-icons/fa";
import { Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function Phone_Number_Reset() {
  const [phone, setPhone] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
   const [activeTab, setActiveTab] = useState("Phone_Reset");

  return (
    <>
      {/* Tabs */}
      <div className="login-tabs">
        <div
          className={`tab ${activeTab === "Phone_Reset" ? "active" : ""}`}
          onClick={() => setActiveTab("Phone_Reset")}
        >
          <div>
            <FaMobileAlt />
          </div>
          Phone Reset
        </div>
      </div>
      {/* Phone Number */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/phone.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Phone number
        </Form.Label>

        <PhoneInput
          country={"in"}
          value={phone}
          onChange={(phone) => setPhone(phone)}
          inputClass="custom-phone-input"
          containerClass="custom-phone-container"
          buttonClass="custom-phone-button"
        />
      </div>

      {/* Set Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Set Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder="Set Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

      {/* Confirm Password */}
      <div className="form-group field_holder">
        <Form.Label>
          <img
            src="/assets/images/icons/lock.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Confirm Password
        </Form.Label>

        <div className="password_input">
          <Form.Control
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
          />
          <span
            className="eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
          </span>
        </div>
      </div>

      {/* Invite Code */}
      <div className="form-group field_holder invite_code_wrapper">
        <Form.Label>
          <img
            src="/assets/images/icons/sheild.png"
            alt="icon"
            className="login_lable_icons"
          />{" "}
          Invite Code
        </Form.Label>

        <div className="invite_input">
          <Form.Control
            type="text"
            placeholder="Please Enter the Invitation Code"
          />
          <Button className="send_btn">Send</Button>
        </div>
      </div>
    </>
  );
}

export default Phone_Number_Reset;
